import { httpLink, loggerLink } from '@trpc/client'
import { createTRPCReact } from '@trpc/react-query'
import type { inferRouterInputs, inferRouterOutputs } from '@trpc/server'
import type { AppRouter } from '../../../catalog/catalog-bff/src/routers/index.js'

const getApiUrl = () => {
	// Client-side (browser): always use relative URL - proxied via API route
	if (typeof window !== 'undefined') {
		return '/api/trpc'
	}

	// Server-side (SSR): use internal BFF URL for direct communication
	// CATALOG_BFF_URL is set at runtime (not NEXT_PUBLIC_ to avoid embedding)
	const bffUrl = process.env.CATALOG_BFF_URL
	if (bffUrl && bffUrl.trim().length > 0) {
		return bffUrl.replace(/\/$/, '')
	}

	// Fallback for development
	return 'http://localhost:3002'
}

export const trpc = createTRPCReact<AppRouter>()

export function createTRPCClient() {
	return trpc.createClient({
		links: [
			loggerLink({
				enabled: (opts) =>
					process.env.NODE_ENV === 'development' ||
					(opts.direction === 'down' && opts.result instanceof Error),
			}),
			httpLink({
				url: getApiUrl(),
			}),
		],
	})
}

export type RouterInputs = inferRouterInputs<AppRouter>
export type RouterOutputs = inferRouterOutputs<AppRouter>
